export default [
  {
    path: '/meal/index',
    name: 'PageMeal',
    component: () =>
      import(/* webpackChunkName: "meal" */ '../pages/meal/PageMeal'),
    meta: {
      modular: 171,
      title: '学生用餐',
      info: '学生用餐——首页',
      keepAlive: true
    }
  },
  {
    path: '/meal/stastics',
    name: 'PageMealStastics',
    component: () =>
      import(/* webpackChunkName: "meal" */ '../pages/meal/PageMealStastics'),
    meta: {
      modular: 171,
      title: '统计',
      info: '学生用餐——统计',
      keepAlive: true
    }
  },
  {
    path: '/meal/calendar',
    name: 'PageMealCalendar',
    component: () =>
      import(/* webpackChunkName: "meal" */ '../pages/meal/PageMealCalendar'),
    meta: {
      modular: 171,
      title: '详情',
      info: '学生用餐——个人明细',
      keepAlive: true
    }
  },
  {
    path: '/meal/export',
    name: 'PageMealExport',
    component: () =>
      import(/* webpackChunkName: "meal" */ '../pages/meal/PageMealExport'),
    meta: {
      modular: 171,
      title: '导出报表',
      info: '学生用餐——导出报表',
      keepAlive: true
    }
  },
  {
    path: '/meal/setting',
    name: 'PageMealSetting',
    component: () =>
      import(/* webpackChunkName: "meal" */ '../pages/meal/PageMealSetting'),
    meta: {
      modular: 171,
      title: '学生用餐',
      info: '学生用餐——设置',
      keepAlive: true
    }
  },
  {
    path: '/meal/notice',
    name: 'PageSettingNotice',
    component: () =>
      import(/* webpackChunkName: "meal" */ '../pages/meal/PageSettingNotice'),
    meta: {
      modular: 171,
      title: '通知人员',
      info: '学生用餐——通知人员',
      keepAlive: true
    }
  }
]
